import { instance } from './_config.js'



const getTiers = async (obj) => {
    try {
        const rs = await instance.post(`/tiers/search`, obj)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateTier = async (obj) => {
    try {
        const rs = await instance.post(`tiers`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteTier = async (id) => {
    try {
        const rs = await instance.delete(`tiers`, { data: { '_id': id }})
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getTiers, updateTier, deleteTier }